import styled from '@emotion/styled'

export const Header = styled.header`
  display: flex;
  align-items: center;
  height: 40px;
`
